const getArrToObjectOfTrues = (arr: string[] | null) => {
    if (!arr) {
        return {};
    }
    return arr.reduce((result, currentString) => {
        // @ts-ignore
        result[currentString] = true;
        return result;
    }, {});
};

export default getArrToObjectOfTrues;
